import { hot } from 'react-hot-loader/root'
import React from 'react'
import { BrowserRouter } from 'react-router-dom'

import BookingAvailability from 'parking-availability/js/BookingAvailability'

const App = () => (
    <BrowserRouter>
        <BookingAvailability />
    </BrowserRouter>
)

export default hot(App)
